import { useState, useEffect, useContext } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Label, MessageBar, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, webDarkTheme, Card, Title2, Subtitle2, Subtitle1, Image, Input, ButtonProps, Tooltip, ProgressBar } from "@fluentui/react-components";
import { DesktopCheckmark20Regular, WrenchScrewdriver20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowMaximize20Regular, DismissSquare24Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, Info16Filled, Info20Filled, Dismiss16Regular, AlertBadge20Regular, CheckmarkLock20Regular, FilterAdd20Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { Troubleshooter_func } from "../../api/troubleshoot/troubleshooter_func";
import { ToastComponent } from "../../components/toast/toast.component";
import { TroubleshooterDevice_fun } from '../../api/troubleshoot/troubleshooterDevice_fun';
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../components/form-components';
import { GlobalContext } from "../../hooks/globalContext";
import { FullScreen } from "react-full-screen";
import { DataTableDevice } from "../../components/data_table/data_table.Device";
import { useFullScreenHandle } from "react-full-screen";
import { Activity_log_func } from "../../api/activity_log/activity_log_func"
import { Accordion, AccordionHeader, AccordionItem, AccordionPanel } from "@fluentui/react-components";
import DialogBox from "../../components/dialog/dialog.component";
import { fullscreenIcon, primaryIcon, exitIcon, secondaryIcon, buttonContent, overflowDivider, horizontalDivider, lightTheme, skeleton12, dividerWidthStyle, heightResponsive, DynamicBoxingCSS, parentHome, wraperStyle, heightOverlayResponsive, tableDiv, overlayTableHeight, oveyAlignment, homeCard, childHome, SubSectionResponsive, dashboardTheme, BreadcrumbsBorder } from "../../styles/customStyles";
import { shouldLoadRoute } from "../../Authentication/RouteProtection";
import { usePermissionStore } from "../../Store/permissionStore";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { InfoBar } from "../../components/infoBar/infoBar.component";
import DynamicSkeleton from "../../components/skeleton/skeletonCommon";
import { SkeletonOverlayDataTable } from "../../components/skeleton/skeletonOverlayDataTable";
import { TroubleshootPages } from "../../components/side_menu/InlineSidenav";

interface AccordionItem {
	heading: string;
	content: string;
}

const handleExportCSV = () => {
	const csvExportLink = document.getElementById('csv-export-link');
	if (csvExportLink) {
		csvExportLink.click();
	}
};

export const TroubleShoot = () => {
	const navigate = useNavigate();
	const [final_data, set_final_data]: any = useState(null);
	const [final_data1, set_final_data1]: any = useState(null);
	const [final_data2, set_final_data2]: any = useState(null);
	const [tableData, setTableData] = useState([]);
	const [tableData1, setTableData1] = useState([]);
	const [tableData2, setTableData2] = useState([]);
	const [leftOpen, setLeftOpen] = useState(false);
	const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
	const [overlayOpen, setOverlayOpen] = useState(false);
	const [searchVal, setSearchVal] = useState("");
	const [dropDownValue1, setDropDownValue1] = useState<any>();
	const [dropDownValue2, setDropDownValue2] = useState<any>();
	const [dropDownValue3, setDropDownValue3] = useState<any>();
	const [dropDownValue4, setDropDownValue4] = useState<any>();
	const [filterArray, setFilterArray] = useState<string[]>([]);
	const [filterArrayDevice, setFilterArrayDevice] = useState<string[]>([]);
	const [isfilter, setIsFilter] = useState(false);
	const [isfilterDevice, setIsFilterDevice] = useState(false);
	const [filterMenuOpen, setFilterMenuOpen] = useState(false);
	const [isResetDisabled, setResetDisabled] = useState(true);
	const [searchDevVal, setSearchDevVal] = useState("");
	const [totalPages, setTotalPages] = useState(1);
	const [totalSubPages, setTotalSubPages] = useState(1);
	const [currentPageNo, setCurrentPageNo] = useState(1);
	const [totalRecords, setTotalRecords] = useState(0);
	const [totalSubRecords, setTotalSubRecords] = useState(0);
	const [messagebar1, setmessagebar1] = useState(false);
	const [messagebar2, setmessagebar2] = useState(false);
	const [subAutomationDetails, setSubAutomationDetails]: any = useState({});
	const [jsonSchema, setJsonData]: any = useState({});
	const [uiSchema, setUiData]: any = useState({});
	const [exportData, setExportData]: any = useState([]);
	const [exportDetails, setExportDetails]: any = useState([]);
	const [exportBtnClicked, setExportBtnClicked] = useState(false);
	const handleBothSetMessage = () => {
		setmessagebar1(false);
		//setmessagebar2(true);
	};
	const [selectedData, setselectedData] = useState({ name: '', desc: '', displayName: '', subAutomation: '' });
	const [allDevice, setallDevice] = useState(false);
	const [groupName, setGroupName] = useState('');
	const [overLayData, setOverLayData] = useState({});
	const contextValue: any = useContext(GlobalContext);
	const tenantName = contextValue.tenantName;
	const [executeBtnClicked, setExecuteBtnClicked] = useState(false);
	// const [toastMessage, setToastMessage] = useState('Push Failed');
	const [toastMessage, setToastMessage] = useState('Push Successful');
	const [toastIntent, setToastIntent] = useState('success');
	const [isRefresh, setIsRefresh]: any = useState(false);
	const [refreshToast, setRefreshToast]: any = useState(false);
	const [isToast, setIsToast] = useState(false);
	const handle = useFullScreenHandle();
	const [accordionItems, setAccordionItems] = useState<AccordionItem[]>([]);
	const [machineStatus, setMachineStatus]: any = useState({});
	const [pendingJob, setPendingJob]: any = useState(false);
	const [deletePendingJob, setDeletePendingJob]: any = useState(false);
	const [pending, setPending]: any = useState(false);
	const { permissions } = usePermissionStore();
	console.log("checking the permissions------>", permissions);
	const [loading, setLoading] = useState(true);
	const [loadingDevice, setLoadingDevice] = useState(true);
	const [rowDesc, setRowDesc]: any = useState(null);
	const [previousJob, setPreviousJob]: any = useState(false);
	const [emptyPendingJob, setEmptyPendingJob]: any = useState(false);
	const [troubleshootErrorMsg, setTroubleshootErrorMsg]: any = useState(false)
	const [tableColumnsData, setTableColumnsData] = useState([]);
	const [filterColumnsData, setFilterColumnsData] = useState([]);
	const [pushClassification, setPushClassification]: any = useState();
	const [pushClassificationType, setPushClassificationType]: any = useState();

	const [isOverlayFilter, setIsOverlayFilter] = useState(false);
	const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
	const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
	const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
	const [overlayFilterArray, setOverlayFilterArray] = useState<string[]>([]);
	const [isOverlayResetDisabled, setOverlayResetDisabled] = useState(true);
	const [uniqueOS, setUniqueOS] = useState([]);
	const [isOsName, setOsName] = useState([]);
	const [isAutomationLoading, setIsAutomationLoading] = useState(true);

	const [totalOverlayPages, setTotalOverlayPages] = useState(1);
	const [currentOverlayPageNo, setCurrentOverlayPageNo] = useState(1);
	const [totalOverlayRecords, setTotalOverlayRecords] = useState(0);
	const [uniqueCategory, setUniqueCategory] = useState([]);
	const [categoryOptions, setCategoryOptions] = useState([]);
	const [isProgressLoading, setProgressLoading] = useState(false);

	useEffect(() => {
		console.log("uniqueCategory sala", uniqueCategory)
		setCategoryOptions(uniqueCategory?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })))
		console.log("CATEGORY yo want", uniqueCategory);
	}, [uniqueCategory])


	const inputChange = (e: any) => {
		const enteredValue = e.target.value;
		console.log("entered value", enteredValue)
		let name = e.target.name;
		const regexS = /^[A-Za-z ]*$/;
		const regexSN = /^[A-Za-z0-9 ]*$/;
		const regexN = /^[0-9]*$/;
		if (name === 'filter' && dropDownValue1 === ("Description") || dropDownValue1 === ("Subcategory") || dropDownValue1 === ("Name") || dropDownValue1 === ("Category description") || dropDownValue1 === ("Sub Category description")) {
			if (regexS.test(enteredValue)) {
				setDropDownValue2(enteredValue);
			}
		}
	}
	const handleFilterArray = (): any => {
		const value1 = overlayOpen ? dropDownValue3 : dropDownValue1;
		const value2 = overlayOpen ? dropDownValue4 : dropDownValue2;
		if (value1 !== undefined && value1 !== "" && value2 !== undefined && value2 !== "") {
			const result = value1 + " : " + value2;
			overlayOpen ? setFilterArrayDevice([...filterArrayDevice, result]) : setFilterArray([...filterArray, result]);
			overlayOpen ? setIsFilterDevice(true) : setIsFilter(true);
		}
	}

	const handleCloseFilter = (index: any): any => {
		console.log("clicked");
		const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
		setFilterArray(updatedArray);
	}

	useEffect(() => {
		if (filterArray.length > 0)
			setResetDisabled(false)
	}, [filterArray])

	const handleOverlayFilter = (): any => {
		const value1 = dropDownValue1Overlay;
		const value2 = dropDownValue2Overlay;
		const result = value1 + " : " + value2;
		setOverlayFilterArray([...overlayFilterArray, result])
		// setIsFilter(true);
		setIsOverlayFilter(true);
		setLoadingDevice(true);
		setDropDownValue1Overlay('');
		setDropDownValue2Overlay('');
	}

	const handleCloseOverlayFilter = (index: any): any => {
		console.log(" handleCloseOverlayFilter clicked");
		const updatedArray = overlayFilterArray.filter((x, itemIndex) => itemIndex !== index);
		setOverlayFilterArray(updatedArray);
		setLoadingDevice(true);
	}

	const overlayInputChange = (e: any) => {
		const enteredValue = e.target.value;
		console.log("entered value", enteredValue)
		let name = e.target.name;
		const regexS = /^[A-Za-z ]*$/;
		const regexSN = /^[A-Za-z0-9_-]*$/;
		const regexN = /^[0-9]*$/;
		if (name === 'filter' && dropDownValue1Overlay === ("Device Name") || dropDownValue1Overlay === ("Device Classification")) {
			if (regexS.test(enteredValue)) {
				setDropDownValue2Overlay(enteredValue);
			}
		}
	}

	useEffect(() => {
		setOverlayResetDisabled(overlayFilterArray.length > 0 ? false : true);
	}, [overlayFilterArray]);

	useEffect(() => {
		const operatingSystemName: any = uniqueOS.map((item) => {
			console.log("items", item);
			return {
				key: item,
				label: <Caption1>{item}</Caption1>
			};
		});

		setOsName(operatingSystemName);
		console.table("operatingSystemName test", operatingSystemName);
	}, [uniqueOS])


	useEffect(() => {
		console.log("final_data=", final_data);

		if (final_data !== undefined && final_data !== null) {
			const newUniqueOs: any = [];

			final_data.forEach((val: any) => {
				// Ensure the OS name is valid and not already in the list
				if (val.os && val.os.trim() !== "-" && !newUniqueOs.includes(val.os)) {
					newUniqueOs.push(val.os);
				}
			});

			setUniqueOS(newUniqueOs);
			console.log("Unique operating System:", newUniqueOs);
		} else {
			setUniqueOS([]);
		}
	}, [final_data]);


	// useEffect(() => {
	// 	console.log('subAutomationDetails useeffect:', subAutomationDetails)
	// 	// setTimeout(() => {
	// 		subAutomationDetails.length > 0 && setIsAutomationLoading(false);
	// 	// }, 500);
	// }, [subAutomationDetails])

	useEffect(() => {
		if (!overlayOpen) {
			setTimeout(() => {
				setIsAutomationLoading(true);
				setSubAutomationDetails({});
			}, 1000);
		}
	}, [overlayOpen])

	//data table column name code starts here
	// var columns = [
	// 	{ key: "automationName", label: <Body1Strong>&nbsp; Name </Body1Strong> },
	// 	{ key: "description", label: <Body1Strong> Description </Body1Strong> },
	// 	{ key: "category", label: <Body1Strong> Category </Body1Strong> },
	// 	{ key: "category_description", label: <Body1Strong> Category description </Body1Strong> },
	// 	{ key: "subCategory", label: <Body1Strong> Sub Category </Body1Strong> },
	// 	{ key: "sub_category_description", label: <Body1Strong> Sub Category description </Body1Strong> },
	// ];
	//data table column name code ends here
	//the data table for filter starts here
	// var columns1 = [
	// 	{ key: "automationName", label: <Caption1> Name </Caption1> },
	// 	{ key: "description", label: <Caption1> Description </Caption1> },
	// 	{ key: "category", label: <Caption1> Category </Caption1> },
	// 	{ key: "subCategory", label: <Caption1> Sub Category </Caption1> },
	// ];
	var tableColumns: any[] = [];
	var filterColumns: any[] = [];
	useEffect(() => {
		contextValue?.tableColumnsData?.Troubleshoot?.Troubleshoot_remediation.forEach((val) => {
			if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
				tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
			}

			if (val.display.filter.toLocaleLowerCase() === "yes") {
				filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
			}
		});

		setTableColumnsData(tableColumns);
		setFilterColumnsData(filterColumns);

		contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Troubleshoot?.Troubleshoot_remediation.filter((val) => val.priority >= 0));

		contextValue.setManageViewPageDetails({ module: "Troubleshoot", page: "Troubleshoot_remediation" });
	}, [contextValue.tableColumnsData]);

	//overlay datatable code start here
	var overlayColumns = [
		{ key: "host", label: <Body1Strong>Device Name</Body1Strong> },
		// { key: "site", label: <Body1Strong>Device Classification</Body1Strong> },
		{ key: "os", label: <Body1Strong>Operating System</Body1Strong> },
	];

	var overlayColumns2 = [
		{ key: "classificationName", label: <Body1Strong> All Device Name</Body1Strong> },
	];
	//overlay datatable code ends here

	// overflow set contents code starts here
	var overFlowComponent = {
		data:
			<>
				<StackItem>
					<Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true); }}>
						<Stack tokens={{ childrenGap: 5 }} horizontal>
							<StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
							<StackItem> <Caption1> Refresh </Caption1> </StackItem>
						</Stack>
					</Button>
				</StackItem>

				<StackItem>
					{permissions.includes("all") ||
						permissions.includes("tshoot_Fullaccess") || permissions.includes("tshoot_ReadandExport") ? (
						<StackItem>
							<CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_configurationlist.csv`}>
							</CSVLink>
							<Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); setProgressLoading(true); }}>
								<Stack tokens={{ childrenGap: 5 }} horizontal>
									<StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
									<StackItem> <Caption1> Export </Caption1> </StackItem>
								</Stack>
							</Button>
						</StackItem>
					) :
						<Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
							<Button shape="circular" appearance="subtle" size="small" disabled>
								<Stack tokens={{ childrenGap: 5 }} horizontal>
									<StackItem><Text></Text></StackItem>
									<StackItem>
										<Stack tokens={{ childrenGap: 5 }} horizontal>
											<StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
											<StackItem><Caption1> Export </Caption1></StackItem>
										</Stack>
									</StackItem>
								</Stack>
							</Button>
						</Tooltip>
					}
				</StackItem>

				{contextValue?.logedInFrom?.platform !== "ServiceNow" && <StackItem>
					<Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
						<Stack tokens={{ childrenGap: 5 }} horizontal>
							<StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
							<StackItem> <Caption1> Manage View </Caption1> </StackItem>
						</Stack>
					</Button>
				</StackItem>}
				
				<StackItem grow shrink>
					<Stack horizontalAlign="end">
						<StackItem grow shrink>
							<FullScreenButton handle={handle} />
						</StackItem>
					</Stack>
				</StackItem>
			</>
		,
	};
	// overflow set contents code ends here

	var tempTableData: any = [];
	var menuLists: any = [];
	var tempExportData: any = [];

	useEffect(() => {
		var tempExportData: any = [];

		exportDetails?.length > 0 && exportDetails.map((val: any) => {
			var NewValue = val && JSON.parse(val.jsonValue);
			//console.log("NewValue==============", val.jsonValue);

			tempExportData.push({
				'Name': val.automationName,
				'Description': val.description,
				'Category': val.category,
				'Category Description': NewValue.category_description,
				'Type': val.types,
				'Sub Category': val.subCategory,
				'Sub Category Description': NewValue.sub_category_description ? NewValue.sub_category_description : '-',
			});
		});

		setExportData(tempExportData);
	}, [exportDetails]);

	useEffect(() => {
		exportData.length > 0 && document.getElementById('csv-export-link')?.click();
		setProgressLoading(false);
	}, [exportData]);

	const automationAction = async (e: any, NewValue: any, val: any) => {
		console.log('on click setRowDesc')
		// e.preventDefault();
		console.log('newvalue: ', NewValue)
		console.log('val: ', val)
		setOverlayOpen(true);
		setRowDesc(val.automationName)
		setallDevice(true);
		console.log('newvalue: ', val.automationName)
		setselectedData({ name: NewValue.automation_name, desc: NewValue.description, displayName: val.automationName, subAutomation: NewValue.automation_sequence })
	}

	useEffect(() => {
		console.log("final_data=", final_data);

		if (final_data !== undefined && final_data !== null) {
			let newUniqueCategory: any = [];

			final_data.forEach((val: any) => {
				// Ensure the OS name is valid and not already in the list
				if (val.category && val.category.trim() !== "-" && !newUniqueCategory.includes(val.category)) {
					newUniqueCategory.push(val.category);
				}
			});
			setUniqueCategory(newUniqueCategory);
			console.log("new unique category", newUniqueCategory)
		} else {
			setUniqueCategory([]);
		}
	}, [final_data]);

	useEffect(() => {
		// data table values append code starts here

		final_data !== undefined && final_data !== null
			? final_data.map((val: any, i: any) => {
				var NewValue = val && JSON?.parse(val?.jsonValue);
				console.log(`value is here ${val.automationName}`);

				if (permissions.includes("tshoot_Read") || permissions.includes("tshoot_ReadandExport")) {
					tempTableData.push({
						id: NewValue.automationName,
						checkbox: "hide",
						automationName: { label: <Button id="ButtonHover" style={buttonContent} size="small" appearance="transparent" onClick={(e) => { automationAction(e, NewValue, val); }}> {val.automationNam ? val.automationNam : '-'} </Button>, icon: "", id: `${i}` },
						description: { label: <Caption1> {NewValue.description ? NewValue.description : '-'} </Caption1>, status: "" },
						category: { label: <Caption1> {NewValue.category ? NewValue.category : '-'} </Caption1> },
						category_description: { label: <Caption1> {NewValue.category_description} </Caption1> },
						subCategory: { label: <Caption1> {NewValue.sub_category ? NewValue.sub_category : '-'} </Caption1> },
						sub_category_description: { label: <Caption1> {NewValue.sub_category_description ? NewValue.sub_category_description : '-'} </Caption1> },
						jsonValue: { label: <Caption1> {val.jsonValue ? val.jsonValue : '-'} </Caption1> },
					});

				} else if (permissions.includes("all") || permissions.includes("tshoot_Fullaccess")) {
					tempTableData.push({
						id: NewValue.automationName,
						checkbox: "hide",
						automationName: { label: <Button id="ButtonHover" style={buttonContent} size="small" appearance="transparent" onClick={(e) => { automationAction(e, NewValue, val); }}> {val.automationName ? val.automationName : ''} </Button>, icon: "", id: `${i}` },
						description: { label: <Caption1> {NewValue.description ? NewValue.description : '-'} </Caption1>, status: "" },
						category: { label: <Caption1> {NewValue.category ? NewValue.category : '-'} </Caption1> },
						category_description: { label: <Caption1> {NewValue.category_description} </Caption1> },
						subCategory: { label: <Caption1> {NewValue.sub_category ? NewValue.sub_category : '-'} </Caption1> },
						sub_category_description: { label: <Caption1> {NewValue.sub_category_description ? NewValue.sub_category_description : '-'} </Caption1> },
						jsonValue: { label: <Caption1> {val.jsonValue ? val.jsonValue : '-'} </Caption1> },
					});
				}
			}) : (tempTableData = []);

		setTimeout(() => {
			final_data !== undefined && final_data !== null && setLoading(false);
		}, 500);
		tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
	}, [final_data, permissions]);
	// data table values append code ends here

	useEffect(() => {
		console.log('rowDesc has been updated:', rowDesc);
	}, [rowDesc]);

	useEffect(() => {
		console.log("sub", contextValue?.selectedRowIdInTable.length)
		console.log("final", final_data1?.length)
		console.log("alldevice", allDevice)
		console.log("groupname", groupName)
		console.log("true", contextValue.selectedRowIdInTable == final_data1?.length)

		if (allDevice && contextValue.selectedRowIdInTable.length === final_data1?.length) {
			setPushClassification("Classification")
			setPushClassificationType("All Devices");
		}
		else if (allDevice && contextValue.selectedRowIdInTable.length != final_data1?.length) {
			setPushClassification("Machine");
			setPushClassificationType("");
		}
		else if (!allDevice) {
			setPushClassification("Classification");
			setPushClassificationType(groupName);
		}
		console.log("pushclassification", pushClassification)
	}, [contextValue.selectedRowIdInTable])

	useEffect(() => {
		// Overlay data table values append code starts here
		console.log("final_data1*************", final_data1);
		console.log("machineStatus***********", machineStatus);
		tempTableData = [];
		final_data1 !== undefined && final_data1 !== null
			? final_data1.map((val: any, i: any) => {
				var deviceStatus: any = Object.keys(machineStatus).length === 0 ? 'offline' : machineStatus[`${val.host}`] !== undefined ? machineStatus[`${val.host}`][0] : 'offline';
				var deviceType: any = Object.keys(machineStatus).length === 0 ? 'default' : machineStatus[`${val.host}`] !== undefined ? machineStatus[`${val.host}`][1] : 'default';

				var currentIcon = <Badge size="extra-small" appearance="filled" color={deviceStatus === 'online' ? "success" : "informative"} > </Badge>;

				if (deviceStatus === 'online') {
					if (deviceType == 1) {
						currentIcon = <Image src="/Dashboard/image/G_Win.svg" alt="Analyze Icon" />;
					} else if (deviceType == 2) {
						currentIcon = <Image src="/Dashboard/image/G_Android.svg" alt="Analyze Icon" />;
					} else if (deviceType == 5) {
						currentIcon = <Image src="/Dashboard/image/G_Apple.svg" alt="Analyze Icon" />;
					}
				} else if (deviceStatus === 'offline') {
					if (deviceType == 1) {
						currentIcon = <Image src="/Dashboard/image/Windows.svg" alt="Analyze Icon" />;
					} else if (deviceType == 2) {
						currentIcon = <Image src="/Dashboard/image/android.svg" alt="Analyze Icon" />;
					} else if (deviceType == 5) {
						currentIcon = <Image src="/Dashboard/image/apple.svg" alt="Analyze Icon" />;
					}
				}

				tempTableData.push({
					id: `${val.host}-/-${deviceStatus}`,
					//checkbox: Object.keys(machineStatus).length === 0 ? 'hide' : (machineStatus[`${val.host}`] !== undefined && machineStatus[`${val.host}`].length > 0) ? "show" : 'hide',
					host: { label: <Caption1> {val.host} </Caption1>, icon: currentIcon, id: `${i}` },
					site: { label: <Caption1> {allDevice == true ? val.site : groupName} </Caption1>, icon: "", status: "" },
					os: { label: <Caption1> {val.os != undefined ? val.os : "-"} </Caption1> }
				});
			}) : (tempTableData = []);

		tempTableData.length > 0 ? setTableData1(tempTableData) : setTableData1([]);

		setTimeout(() => {
			console.log("fd1=", final_data1);

			final_data1 !== undefined && final_data1 !== null && setLoadingDevice(false);
		}, 500);
	}, [final_data1, machineStatus, allDevice, groupName]);

	// useEffect(() => {
	// 	// Overlay device table values append code starts here
	// 	final_data2 !== undefined && final_data2 !== null
	// 		? final_data2 && final_data2.core_DeviceClassification.map((val: any, i: any) => {
	// 			const deviceData = val && val.classificationName

	// 			return <Caption1>{deviceData} </Caption1>;
	// 		}) : (console.log("null"));
	// }, [final_data2]);

	useEffect(() => {
		contextValue.setSelectedRowIdInTable([]);
	}, []);

	useEffect(() => {
		contextValue?.logedInFrom?.device?.length > 0 && setSearchDevVal(contextValue.logedInFrom.device);
	}, [contextValue.logedInFrom]);

	//overlay code starts here
	useEffect(() => {
		console.log("SearchDevVal=", searchDevVal);

		setOverLayData({
			headerTitle:
				(
					<StackItem>
						<FluentProvider theme={dashboardTheme}>
							<Title3>
								{selectedData.displayName.length > 0 ? selectedData.displayName : ''}

							</Title3>
						</FluentProvider>
					</StackItem>),
			size: "large",
			isTabs: true,

			tabItems: {
				// Introduction:
				// 	<>
				// 		<FluentProvider theme={dashboardTheme}>
				// 			<Stack tokens={{ childrenGap: 15, padding: 10 }}>
				// 				<StackItem> <Body1Strong> What does this Troubleshooter Do? </Body1Strong> </StackItem>
				// 				<StackItem> <Caption1> Prevent data in Office mobile apps from being shared or leaked to unmanaged apps on iOS and Android devices. In this scenario, you’ll apply data protection settings to your organization’s managed mobile apps. </Caption1> </StackItem>
				// 				<StackItem> <Body1Strong> What is the benefit? </Body1Strong> </StackItem>
				// 				<StackItem> <Caption1> Prevent data in Office mobile apps from being shared or leaked to unmanaged apps on iOS and Android devices. In this scenario, you’ll apply data protection settings to your organization’s managed mobile apps. </Caption1> </StackItem>
				// 				<StackItem> <Body1Strong> What is the User impact? </Body1Strong>  </StackItem>
				// 				<StackItem> <Caption1> Assigned iOS and Android users must enter a PIN or use biometrics to access work or school content after a period of inactivity. After 5 failed PIN attempts, user must reset their PIN. </Caption1> <Caption1> If advanced data protection controls are enforced, users will not be able to share work or school content with personal apps or personal accounts and will be required to use Microsoft Edge. </Caption1> </StackItem>
				// 				<StackItem> <Body1Strong> Prerequisites, if any</Body1Strong>  </StackItem>
				// 				<StackItem> <Caption1> Managed Apps Create,Read,Assign,Delete Permission </Caption1> <Caption1> Policy sets read, create, and assign permissions. </Caption1> </StackItem>
				// 			</Stack>
				// 		</FluentProvider>
				// 	</>,

				Configuration:
					<>

						<Stack>
							<StackItem><Text></Text></StackItem>
							{isAutomationLoading ? (
								<Stack>
									<DynamicSkeleton
										count={7}
										size={48}
										gap={10}
										style={skeleton12}
									/>
								</Stack>
							)
								:
								(Object.keys(jsonSchema).length > 0 && Object.keys(uiSchema).length > 0 && subAutomationDetails.length > 0 &&
									subAutomationDetails?.map((data: any, i: any) => {
										return (<Accordion collapsible><AccordionItem value="1">
											<AccordionHeader>{data.automationName}</AccordionHeader>
											<AccordionPanel>
												<Form formData={JSON.parse(data?.jsonValue)} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
											</AccordionPanel>
										</AccordionItem> </Accordion>)
									})
								)}
						</Stack>
					</>,

				Devices:
					<>
						<Stack id="troubleshootContainer" style={oveyAlignment} horizontal tokens={{ childrenGap: 10 }}>
							<StackItem style={oveyAlignment}>
								<Stack style={DynamicBoxingCSS}>
									<Stack tokens={{ padding: 5 }}></Stack>
									<StackItem> <Body1Strong> Device&nbsp;Classification </Body1Strong> </StackItem>
									<Stack tokens={{ childrenGap: 10 }}>
										<StackItem><Text></Text></StackItem>
										<StackItem><Divider /></StackItem>
									</Stack>
									<Stack style={tableDiv}>
										<StackItem onClick={() => { setGroupName(""); setallDevice(true); setLoadingDevice(true); }}>
											<FluentProvider theme={groupName === "" ? lightTheme : undefined}>
												<MenuItem> All Devices</MenuItem>
											</FluentProvider>
										</StackItem>
										<StackItem>
											{final_data2 !== undefined && final_data2 !== null ?
												final_data2 && final_data2.map((val: any, i: any) => {
													const deviceData = val.classificationName;
													return (
														<StackItem onClick={() => { setGroupName(deviceData); setallDevice(false); setLoadingDevice(true); }}>
															<FluentProvider theme={groupName === deviceData ? lightTheme : undefined}>
																<MenuItem><Body1> {deviceData} </Body1></MenuItem>
															</FluentProvider>
														</StackItem>
													);
												}) : (console.log("null"))
											}
										</StackItem>
									</Stack>
								</Stack>
							</StackItem>
							<Divider vertical />
							<StackItem style={childHome}>
								{/* RIGHT SIDE DATA HERE */}
								<InfoBar showSpaces={true} title={" Try changing or adding filters if you don't see what you're looking for."} />
								{(contextValue?.logedInFrom === undefined || contextValue?.logedInFrom?.device?.length === undefined) &&
									<Stack horizontal tokens={{ childrenGap: 20 }}>
										<StackItem>
											<Stack wrap horizontal tokens={{ childrenGap: 20 }}>
												<SearchBar columnSearch={"for Devices"} searchVal={searchDevVal} setSearchVal={setSearchDevVal} setLoading={setLoadingDevice} disabled={loadingDevice || tableData1.length===0} />
												<StackItem>
													<MenuDropdown open={filterMenuOpenOverlay} btn={
														<MenuButton disabled={loadingDevice || tableData1.length=== 0 } shape="circular" size="small" onClick={() => setFilterMenuOpenOverlay(true)}>
															<Stack tokens={{ childrenGap: 5 }} horizontal>
																{loadingDevice || tableData1.length === 0 ? <FilterAdd20Filled {...secondaryIcon} /> : <FilterAdd20Filled {...primaryIcon} />}
																<Body1> Filter </Body1>
															</Stack>
														</MenuButton>
													} itemVal={
														<>
															<Body1Strong> Add a Filter </Body1Strong>
															<Divider />
															<MenuList>
																<Stack tokens={{ childrenGap: 5 }}>
																	<StackItem> <Text></Text> </StackItem>
																	<StackItem> <Caption1> Filter </Caption1> </StackItem>
																	<DropdownComponent optionData={overlayColumns} setDropDownValue={setDropDownValue1Overlay} dropDownvalue={dropDownValue1Overlay} />
																	<StackItem> <Divider /> </StackItem>
																	<StackItem> <Caption1> Value </Caption1> </StackItem>
																	{dropDownValue1Overlay === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2Overlay} dropDownvalue={dropDownValue2Overlay} />}
																	{(dropDownValue1Overlay === "Device Name" || dropDownValue1Overlay === "Device Classification") && <Input size='small' onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />}
																	<StackItem>
																		<Divider />
																	</StackItem>
																	<Stack tokens={{ childrenGap: 10 }} horizontal>
																		<StackItem>
																			<Button shape="circular" appearance="primary" onClick={() => { handleOverlayFilter(); setFilterMenuOpenOverlay(false) }}
																				disabled={!dropDownValue1Overlay || !dropDownValue2Overlay || overlayFilterArray.includes(`${dropDownValue1Overlay} :`)}>
																				<Caption1> Apply </Caption1>
																			</Button>
																		</StackItem>
																		<StackItem>
																			<Button shape="circular" onClick={() => setFilterMenuOpenOverlay(false)}>     <Caption1> Cancel </Caption1>
																			</Button>
																		</StackItem>
																	</Stack>
																</Stack>
															</MenuList>
														</>}
													/>
												</StackItem>

												<StackItem onClick={() => { setOverlayFilterArray([]); setIsFilter(false); setDropDownValue2(''); setOverlayResetDisabled(true); setLoadingDevice(true); }}>
													<Button shape="circular" appearance="subtle" size="small" disabled={isOverlayResetDisabled}>
														<Stack tokens={{ childrenGap: 5 }} horizontal>
															<StackItem> <FilterDismiss20Filled /> </StackItem>
															<StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
														</Stack>
													</Button>
												</StackItem>
												<StackItem>
													{overlayFilterArray.length > 0 && overlayFilterArray.map((item, index) => (
														<Button shape="circular" size="small">
															<Stack tokens={{ childrenGap: 5 }} horizontal>
																<StackItem> {item} </StackItem>
																<StackItem>
																	<Stack tokens={{ childrenGap: 1 }}>
																		<StackItem><Text></Text></StackItem>
																		<StackItem><Dismiss16Regular onClick={() => { handleCloseOverlayFilter(index) }} /></StackItem>
																	</Stack>
																</StackItem>
															</Stack>
														</Button>
													))}
												</StackItem>
											</Stack>
										</StackItem>
									</Stack>
								}
								<Stack style={overlayTableHeight} tokens={{ childrenGap: 10 }}>
										{tableData1.length > 0 && !loadingDevice && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
											<StackItem> {totalOverlayRecords > 0 && <Caption1>  Showing {((currentOverlayPageNo - 1) * 50) + 1} to {(currentOverlayPageNo * 50) > totalOverlayRecords ? totalOverlayRecords : (currentOverlayPageNo * 50)} of {totalOverlayRecords} Records </Caption1>} </StackItem>
											<StackItem> <Pagination setLoading={setLoadingDevice} totalPages={totalOverlayPages} currentPageNo={currentOverlayPageNo} setCurrentPageNo={setCurrentOverlayPageNo} /> </StackItem>
										</Stack>
										}

										{loadingDevice ? (<Stack style={DynamicBoxingCSS}><SkeletonOverlayDataTable /></Stack>) : tableData1.length > 0 ? (
											<Stack style={tableDiv}>
												<DataTable tableData={tableData1} columns={overlayColumns} /></Stack>) :
											<Stack grow disableShrink horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
								</Stack>
							</StackItem>
						</Stack>

						{/* <Stack horizontalAlign="start">
              <StackItem grow shrink>
                <Card appearance="subtle">
                  <Stack tokens={{ childrenGap: 10 }} horizontal>

                    <StackItem>
                      <Body1Strong> Device&nbsp;Classification </Body1Strong>
                      <Stack tokens={{childrenGap:5}}>
                        <StackItem><Text></Text></StackItem>
                        <StackItem><Divider/></StackItem>
                      </Stack>
                      <Stack tokens={{ padding: 5 }} horizontal>
                        <StackItem>   </StackItem>
                      </Stack>
                      <Stack tokens={{ padding: 3, childrenGap: 10 }} horizontalAlign="start" verticalAlign="start" verticalFill >
                        <StackItem onClick={() => { setallDevice(true) }}>
                          <MenuItem> All Devices</MenuItem>
                        </StackItem>
                        <Stack tokens={{ childrenGap: 10 }} verticalFill>     
                        {
                          final_data2 !== undefined && final_data2 !== null
                            ? final_data2 && final_data2.core_DeviceClassification.map((val: any, i: any) => {
                              const deviceData = val.classificationName;
                              return <StackItem onClick={() => { setGroupName(deviceData); setallDevice(false) }} >
                                <MenuItem><Body1> {deviceData} </Body1></MenuItem>
                              </StackItem>;
                            }) : (console.log("null"))
                        }
                        </Stack>

                        {tableData2.length > 0 && groupName != '' && (<DataTable tableData={tableData2} columns={overlayColumns2} />)}
                      </Stack>
                    </StackItem>

                    <Divider vertical />

                    <StackItem>
                      <FluentProvider theme={messageTheme}>
                        <Card appearance="subtle" size="small">
                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                            <StackItem> <Info20Filled {...primaryIcon} /> </StackItem>
                            <StackItem> <Caption1> Try changing or adding filters if you don't see what you're looking for. </Caption1>  </StackItem>
                          </Stack>
                        </Card>
                      </FluentProvider>
                      <Stack tokens={{ padding: 5 }}></Stack>
                      <Stack horizontal tokens={{ childrenGap: 20 }}>
                        <SearchBox onChange={(e: any) => { setSearchDevVal(e.target.value); }} placeholder="Search" size="small" />
                        <StackItem>
                          <MenuDropdown open={filterMenuOpen} btn={
                            <MenuButton shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                              <Stack tokens={{ childrenGap: 5 }} horizontal>
                                {loading?<Filter20Filled {...secondaryIcon} />:<Filter20Filled {...primaryIcon} />}
                                <Body1> Filter </Body1>
                              </Stack>
                            </MenuButton>
                          } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                            <Divider />
                            <MenuList>
                              <Stack tokens={{ childrenGap: 5 }}>
                                <StackItem> <Text></Text> </StackItem>
                                <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                <DropdownComponent optionData={columns1} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                                <StackItem> <Divider /> </StackItem>
                                <StackItem> <Caption1> Value </Caption1> </StackItem>
                                <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
                                <StackItem> <Divider /> </StackItem>
                                <Stack tokens={{ childrenGap: 10 }} horizontal>
                                  <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
                                  <StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                                </Stack>
                              </Stack>
                            </MenuList>
                          </>} />
                        </StackItem>
                        <StackItem>
                          {filterArray.length > 0 && filterArray.map((item, index) => (
                            <Button shape="circular" size="small" shape="circular">
                              <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem> {item} </StackItem>
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 1 }}>
                                    <StackItem><Text></Text></StackItem>
                                    <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </Button>
                          ))}
                        </StackItem>
                        <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                          <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                              <StackItem> <FilterDismiss20Filled /> </StackItem>
                              <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                            </Stack>
                          </Button>
                        </StackItem>
                      </Stack>

                      <Stack tokens={{ childrenGap: 10 }}>
                        <FluentProvider theme={dashboardTheme}>
                          {tableData1.length > 0 ? (<DataTable tableData={tableData1} columns={overlayColumns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No data available</Text></StackItem></Stack>}

                        </FluentProvider>
                      </Stack>

                    </StackItem>

                  </Stack>
                </Card>
              </StackItem>
            </Stack> */}
					</>,

			},

			footerData:
				(
					<>
						{/* <Button shape="circular" appearance="primary" disabled={contextValue.selectedRowIdInTable.length > 0 ? false : true} onClick={() => { setmessagebar1(true); }}>
            Execute this Fix
          </Button> */}

						<DialogBox
							headerButton={
								<>
									<Stack tokens={{ childrenGap: 5 }} horizontal>
										<StackItem>
											<Button shape="circular" appearance="primary" size="small" onClickCapture={() => setCurrentPageNo(1)}
												disabled={contextValue.selectedRowIdInTable.length > 0 ? false : true}>
												<Stack tokens={{ childrenGap: 5 }} horizontal>
													<StackItem> <Caption1> Push Solution </Caption1> </StackItem>
												</Stack>
											</Button>
										</StackItem>
									</Stack>
								</>
							}

							content={`Are you sure you want to execute the solution: ${selectedData.displayName} : ${contextValue.selectedRowIdInTable
								.length} devices under ${groupName.length > 0 ?  groupName : 'All Devices'}?`}

							footer=
							{
								<>
									<Stack horizontal tokens={{ childrenGap: 10 }}>
										<StackItem>
											{<Button shape="circular" appearance="primary" onClick={handleBothSetMessage} size="small" onClickCapture={() => { setExecuteBtnClicked(true); }}>Confirm</Button>}
										</StackItem>
										<StackItem>
											<Button shape="circular" size="small">Cancel</Button>
										</StackItem>
									</Stack>
								</>
							}
						/>

						<DialogBox
							headerButton={
								<>
									<Stack tokens={{ childrenGap: 5 }} horizontal>
										<StackItem>
											<Button shape="circular" appearance="primary" size="small" /*onClick={() => { setPending(true) }}*/> Clear Pending queue </Button>
										</StackItem>
									</Stack>
								</>
							}

							content={"Are you sure you want to proceed with clearing pending jobs"}

							footer=
							{
								<>
									<Stack horizontal tokens={{ childrenGap: 10 }}>
										<StackItem>
											{<Button shape="circular" appearance="primary" size="small" onClick={() => { setPendingJob(true); }}> Confirm </Button>}
										</StackItem>
										<StackItem>
											<Button shape="circular" size="small">Cancel</Button>
										</StackItem>
									</Stack>
								</>
							}
						/>
					</>
				),
		});
	}, [selectedData, groupName, final_data1, tableData1, contextValue.selectedRowIdInTable, searchDevVal, allDevice, subAutomationDetails, uiSchema, jsonSchema, final_data2, executeBtnClicked, isOverlayFilter, filterMenuOpenOverlay, overlayFilterArray, dropDownValue1Overlay, dropDownValue2Overlay])
	//overlay code ends here

	// useEffect(() => {
	//   //console.log("allDevice====",allDevice);
	// }, [allDevice])

	// useEffect(() => {
	//   //console.log("JsonData=",jsonSchema);
	//   //console.log("uiSchema=",uiSchema);
	// }, [jsonSchema, uiSchema])


	let deviceButtons = null;
	if (final_data2 !== undefined && final_data2 !== null) {
		deviceButtons = final_data2.map((val: any, i: any) => {
			const deviceData = val.classificationName;

			return (
				<StackItem key={i} onClick={() => { setGroupName(deviceData); setallDevice(false); setLoadingDevice(true); }}>
					<Button shape="circular" appearance="transparent" size="small"> {deviceData} </Button>
				</StackItem>
			);
		});
	} else {
		console.log("null");
	}

	return (
		<>
			<FullScreen handle={handle} className="fullScreenBackgroundColor">
				<StackItem grow shrink style={BreadcrumbsBorder}>
					<Stack tokens={{ childrenGap: 10 }} horizontal>
						{contextValue?.logedInFrom?.platform !== "ServiceNow" && <StackItem grow shrink>
							<Stack tokens={{childrenGap:5}} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink> 
                                    {/* <Breadcrumbs pageName="Alert" subPageName="" subPageLink="#" />  */}
                                    <Breadcrumbs 
                                        items={[
										{ name: "Manage", link: "/home" },
                                        { name: "Troubleshoot", link: "/manage/troubleshoot/alert" },
                                        { name: "Remediation", link: "#" }
                                        ]} 
                                    />
                                </StackItem>
                            </Stack>
						</StackItem>}
					</Stack>
				</StackItem>
				<Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
					<StackItem style={DynamicBoxingCSS}>
						<Stack style={DynamicBoxingCSS}>
							{/* <Stack tokens={{ childrenGap: 25 }} horizontal>
							<StackItem><Text/></StackItem>
								<StackItem>
									<FluentProvider theme={dashboardTheme}>
										<Title3> Remediation | Troubleshoot</Title3>
									</FluentProvider>
								</StackItem>
							</Stack> */}
							<FluentProvider style={parentHome} theme={dashboardTheme}>
								<Stack style={parentHome} horizontal>
									<SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={TroubleshootPages("Troubleshoot")} />
									<StackItem style={DynamicBoxingCSS}>
										<Stack style={parentHome} className={isProgressLoading ? 'disabled-opacity' : ''} verticalAlign="center" tokens={{ childrenGap: 10 }}>
											<Stack style={parentHome} tokens={{ childrenGap: 10 }}>
												<StackItem>
													<OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
													<Stack>{isProgressLoading && <ProgressBar />}</Stack>
													<Divider />
												</StackItem>
												<StackItem style={wraperStyle}>
													<StackItem>
														<Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
															<Stack horizontal tokens={{ childrenGap: 10 }}>
															<StackItem>
																<SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
																</StackItem>
																<StackItem>
																	<MenuDropdown open={filterMenuOpen} btn={
																		<MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
																			<Stack tokens={{ childrenGap: 5 }} horizontal>
																				{loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
																				<Body1> Filter </Body1>
																			</Stack>
																		</MenuButton>
																	} itemVal={<><Body1Strong> Add a Filter </Body1Strong>
																		<Divider />
																		<MenuList>
																			<Stack tokens={{ childrenGap: 5 }}>
																				<StackItem> <Text></Text> </StackItem>
																				<StackItem> <Caption1> Filter </Caption1> </StackItem>
																				{/* <DropdownComponent optionData={columns} /> */}
																				<DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
																				<StackItem> <Divider /> </StackItem>
																				<StackItem> <Caption1> Value </Caption1> </StackItem>
																				{(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Category description" || dropDownValue1 === "Sub Category description" || dropDownValue1 === "Sub Category") && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size="small" onChange={inputChange} name="filter" value={dropDownValue2} />))}
																				{dropDownValue1 == "Category" && <DropdownComponent optionData={categoryOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}

																				<StackItem> <Divider /> </StackItem>
																				<Stack tokens={{ childrenGap: 10 }} horizontal>
																					<StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
																					<StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
																				</Stack>
																			</Stack>
																		</MenuList>
																	</>} />
																</StackItem>
																<StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
																	<Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
																		<Stack tokens={{ childrenGap: 5 }} horizontal>
																			<StackItem> <FilterDismiss20Filled /> </StackItem>
																			<StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
																		</Stack>
																	</Button>
																</StackItem>
															</Stack>
															{(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
														</Stack>
														{filterArray.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
															<Stack wrap horizontal >
																{filterArray.length > 0 && filterArray.map((item, index) => (
																	<Button shape="circular" size="small">
																		<Stack tokens={{ childrenGap: 5 }} horizontal>
																			<StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
																			<StackItem>
																				<Stack tokens={{ childrenGap: 1 }}>
																					<StackItem><Text></Text></StackItem>
																					<StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
																				</Stack>
																			</StackItem>
																		</Stack>
																	</Button>
																))}
															</Stack>
														</Stack>}
													</StackItem>
													{/* <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack> */}
													<InfoBar showSpaces={true} title={"Executing the following troubleshooters will assist you in devices management and provide a resolutions for any errors. Be mindful  when executing the troubleshooter on multiple devices."} />
													{tableData.length > 0 && !loading && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
														<StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
													</Stack>
														// : <Stack horizontalAlign="start"  tokens={{childrenGap: 15}}><StackItem><Text></Text></StackItem><StackItem><Caption1> No Results.</Caption1></StackItem></Stack>
													}
												</StackItem>
												<Troubleshooter_func
													filterArray={filterArray}
													data={final_data}
													func={set_final_data}
													searchVal={searchVal}
													pageNo={(currentPageNo - 1) * 50}
													setTotalPages={setTotalPages}
													setTotalRecords={setTotalRecords}
													setExecuteBtnClicked={setExecuteBtnClicked}
													executeBtnClicked={executeBtnClicked}
													selectedAuto={selectedData}
													setmessagebar={setmessagebar2}
													isRefresh={isRefresh}
													setmessage={setToastMessage}
													setToastIntent={setToastIntent}
													setIsRefresh={setIsRefresh}
													setRefreshToast={setRefreshToast}
													setSubAutomationDetails={setSubAutomationDetails}
													setIsAutomationLoading={setIsAutomationLoading}
													setJsonData={setJsonData}
													setUiData={setUiData}
													setExportDetails={setExportDetails}
													exportBtnClicked={exportBtnClicked}
													setExportBtnClicked={setExportBtnClicked}
													isFilter={isfilter}
													dropDownValue1={dropDownValue1}
													setIsFilter={setIsFilter}
													dropDownValue2={dropDownValue2}
													pendingJob={pendingJob}
													setPendingJob={setPendingJob}
													pending={pending}
													setPending={setPending}
													rowDesc={rowDesc}
													setRowDesc={setRowDesc}
													setPreviousJob={setPreviousJob}
													previousJob={previousJob}
													pageName={'troubleshoot'}
													setTroubleshootErrorMsg={setTroubleshootErrorMsg}
													setEmptyPendingJob={setEmptyPendingJob}
													emptyPendingJob={emptyPendingJob}
													overlayopen={overlayOpen}
													setOverlayOpen={setOverlayOpen}
													selectedArray={contextValue.setSelectedRowIdInTable}
													setPushClassification={setPushClassification}
													pushClassification={pushClassification}
													pushClassificationType={pushClassificationType}
													setPushClassificationType={setPushClassificationType} />


												{refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
												{pendingJob && <ToastComponent setmessagebar={setIsToast} isToastEnabled={pendingJob} toastIntent="success" position="top-end" title="Success" message={'Pending Deployment Cleared'} footer="" />}
												{previousJob && <ToastComponent setmessagebar={setIsToast} isToastEnabled={previousJob} toastIntent="info" position="top-end" title="Warning" message={'Previous Deployement Pending, Clear it first'} footer="" />}
												{emptyPendingJob && <ToastComponent setmessagebar={setIsToast} isToastEnabled={previousJob} toastIntent="info" position="top-end" title="Warning" message={'No jobs pending!'} footer="" />}
												{loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
												{troubleshootErrorMsg && (<ToastComponent setmessagebar={setTroubleshootErrorMsg} toastIntent={toastIntent} position="top-end" title={toastIntent.charAt(0).toUpperCase() + toastIntent.slice(1)} message={toastMessage} />)}
												{messagebar2 && (<ToastComponent setmessagebar={setmessagebar2} toastIntent={toastIntent} position="top-end" title={toastIntent.charAt(0).toUpperCase() + toastIntent.slice(1)} message={toastMessage} />)}
											</Stack>
										</Stack>
									</StackItem>
								</Stack>
								<TroubleshooterDevice_fun filterArray={filterArray} groupData={final_data2} groupFunc={set_final_data2} data={final_data1} func={set_final_data1} searchDevVal={searchDevVal} pageNo={(currentPageNo - 1) * 10} setTotalPages={setTotalSubPages} setTotalRecords={setTotalSubRecords} groupName={groupName} setGroupName={setGroupName} allDevice={allDevice} overlayOpen={overlayOpen} setallDevice={setallDevice} setMachineStatus={setMachineStatus} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} setLoadingDevice={setLoadingDevice} isOverlayFilter={isOverlayFilter} dropDownValue1Overlay={dropDownValue1Overlay} setIsOverlayFilter={setIsOverlayFilter} dropDownValue2Overlay={dropDownValue2Overlay} setTotalOverlayPages={setTotalOverlayPages} setTotalOverlayRecords={setTotalOverlayRecords} setCurrentOverlayPageNo={setCurrentOverlayPageNo} overlayPageNo={(currentOverlayPageNo - 1) * 10} overlayFilterArray={overlayFilterArray} selectedData={selectedData} />
							</FluentProvider>
						</Stack>
						<OverLay
							overlayopen={overlayOpen}
							setOverlayOpen={setOverlayOpen}
							overlayData={overLayData}
						/>
					</StackItem>
					<StackItem><Text></Text></StackItem>
				</Stack>
			</FullScreen>
		</>
	);
};